"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export default function ScrollToTop() {
  const pathname = usePathname();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // remove if you want instant jump
    });
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const nextVisible = window.scrollY > 300;
      setShowButton((prev) => (prev === nextVisible ? prev : nextVisible));
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={`scroll-top-btn ${showButton ? "is-visible" : ""}`}
      aria-label="Scroll to top"
    >
      <i className="fas fa-chevron-up" aria-hidden="true" />
    </button>
  );
}
